import React from "react"
import MedicalHistoryCard from "./MedicalHistoryProfileCard"
import HealthCard from "./HealthCard"
import UserDetailsCard from "./UserDetailsCard"
import percentCompleteWrapper from "../../common/components/ProfileSwitcher/components/PercentComplete"

const ProfileDetails = ({
  email,
  selectedProfile,
  updateProfile,
  predispositions,
  dirty,
  error,
  setProfileDirty,
  setProfileError,
  setAnswer,
  saveProfileAnswers,
  editPredispositions,
  cancelEditPredispositions,
  percentsComplete,
}) => (
  <React.Fragment>
    <UserDetailsCard
      initialEmail={email}
      selected={selectedProfile}
      onSave={updateProfile}
      dirty={dirty}
      error={error}
      setProfileDirty={setProfileDirty}
      setProfileError={setProfileError}
      questions={
        predispositions &&
        predispositions.basic_info &&
        predispositions.basic_info.questions
      }
      saveProfileAnswers={saveProfileAnswers}
      setAnswer={setAnswer}
      percentComplete={percentsComplete.basicInfo}
    />
    {predispositions.general_health !== undefined && (
      <HealthCard
        key="general_health"
        name="General Health"
        category="general_health"
        setAnswer={setAnswer}
        questions={predispositions.general_health.questions}
        selected={selectedProfile}
        saveProfileAnswers={saveProfileAnswers}
        editPredispositions={editPredispositions}
        cancelEditPredispositions={cancelEditPredispositions}
        percentComplete={percentsComplete.generalHealth}
      />
    )}
    {predispositions.past_medical_conditions !== undefined &&
      predispositions.past_surgeries && (
        <MedicalHistoryCard
          key="medical_history"
          name="Medical History"
          category="medical_history"
          setAnswer={setAnswer}
          selected={selectedProfile}
          surgicalHistoryCategory="past_surgeries"
          medicalHistoryCategory="past_medical_conditions"
          surgicalHistoryQuestions={predispositions.past_surgeries}
          medicalHistoryQuestions={predispositions.past_medical_conditions}
          saveProfileAnswers={saveProfileAnswers}
          editPredispositions={editPredispositions}
          cancelEditPredispositions={cancelEditPredispositions}
          percentComplete={percentsComplete.medicalHistory}
        />
      )}
    {predispositions.reproductive_health !== undefined && (
      <HealthCard
        key="reproductive_health"
        category="reproductive_health"
        name="Reproductive History"
        setAnswer={setAnswer}
        questions={predispositions.reproductive_health.questions}
        selected={selectedProfile}
        saveProfileAnswers={saveProfileAnswers}
        editPredispositions={editPredispositions}
        cancelEditPredispositions={cancelEditPredispositions}
        percentComplete={percentsComplete.reproductiveHealth}
      />
    )}
  </React.Fragment>
)

const WrappedProfileDetails = percentCompleteWrapper(ProfileDetails)

class ProfileDetailsContainer extends React.Component {
  componentDidUpdate(prevProps) {
    if (
      this.props.selectedProfile.id &&
      (this.props.selectedProfile.id !== prevProps.selectedProfile.id ||
        this.props.selectedProfile.sex !== prevProps.selectedProfile.sex)
      ) {
      this.props.getProfileQuestions(this.props.selectedProfile.id)
    }
  }

  render() {
    return <WrappedProfileDetails {...this.props} />
  }
}

export { ProfileDetailsContainer as default }



// WEBPACK FOOTER //
// ./assets/account/components/ProfileDetails.js